import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAPYBARA_IMPACT_STORY = createFcmDetails('capybara_impact_story', {
	owner: 'narwhal',
	context: 'Impact Story - on/off switch and content for country+locale combo',
	description: 'For each country+locale, define impact story pages available and the content for each page.',
	import: false,
	template: {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'en-US': {
			enabled: false,
			impactStories: {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				'petition-page-slug-for-impact-story': {
					badgeLabel: '',
					title: '',
					videoUrl: '',
					sapImage: '',
					quoteImage: '',
					starterQuote: '',
					paragraphs: ['', ''],
				},
			},
		},
	},
	mergeLogic: 'Displays in order of country, locale, then global',
});
